import { BadgeCategory } from './badge_category.js';
import type { FilterableBadgeCategory } from './badge_category.js';

export function isFilterableCategory(category: BadgeCategory): category is FilterableBadgeCategory {
  return (
    category !== BadgeCategory.NonFiltering &&
    category !== BadgeCategory.Hidden &&
    category !== BadgeCategory.Warning
  );
}

export function isHiddenCategory(
  category: BadgeCategory | undefined,
): category is BadgeCategory.Hidden {
  if (!category) {
    return false;
  }
  return category === BadgeCategory.Hidden || category === BadgeCategory.Warning;
}
